import React from "react";

function Footer() {
  return (
    <footer className="mt-5 bg-black p-4 text-center text-xs text-white">
      <p>&copy; 2024 YoutubeVault Created by Afsha with ❤️</p>
    </footer>
  );
}

export default Footer;
